import Backbone from 'backbone';
import _ from 'underscore';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import BaseTargetsView from '@bingads-webui-campaign-legacy/base-targets/view/baseTargets';
import tmpl from '@bingads-webui-campaign-legacy/base-targets/template/update.pug';
import targetTypes from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetTypes';
import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';
import pageContext from '@bingads-webui-static-legacy/page-context';

export default class View extends Backbone.View {

  initialize(options = {}) {
    this.options = _.defaults(options, {
      targetType: targetTypes.Device,
      campaignId: '',
      adgroupId: '',
      level: 'campaign',
      fromSettingsGrid: false,
      showLevelToggle: true,
    });
  }

  render() {
    this.$el.html(tmpl());

    this.targetsView = new BaseTargetsView(this.options);
    this.$('.update-container').html(this.targetsView.render().el);

    return this;
  }

  toggleCashbackPercentColumns(supportCashbackSettings, inheritInfo) {
    this.targetsView.viewmodel.supportCashbackSettings(supportCashbackSettings && !pageContext.Permissions.IsPersonalizedOffersV3Enabled);
    this.targetsView.viewmodel.resetCashbackInheritInfoInAllRows(inheritInfo);
    this.targetsView.viewmodel.validate();
  }

  getCriterionFilter() {
    switch (this.options.targetType) {
    case targetTypes.Device:
    case targetTypes.OriginalDevice:
      return 'isof(Criterion,DeviceCriterion)';
    case targetTypes.Age:
      return 'isof(Criterion,AgeCriterion)';
    case targetTypes.Gender:
      return 'isof(Criterion,GenderCriterion)';
    default:
      return '';
    }
  }

  getCriterions() {
    return jsData.CampaignCriterion.findAll(
      {query: {$filter: this.getCriterionFilter()}},
      {entitySet: edmCampaign.currentAccount.Campaigns.$withKey(Number(this.options.campaignId)).CampaignCriterions, cacheResponse: false}
    );
  }

  getViewOptions(data, targetKeys, targetType) {
    let result = {
      targetType,
      campaignId: this.options.campaignId,
      adgroupId: this.options.adgroupId,
      level: this.options.level,
    };

    _.each(targetKeys, (key) => {
      let entry = _.find(data, (element) => {
        return element.Criterion[`${targetConstants.targetTypeToFilterProperty[targetType]}`] === key;
      });

      result[`${targetType}Type${key}BidId`] = entry ? entry.Id : '';
      result[`${targetType}Type${key}BidAdjustment`] = entry ? entry.CriterionBid.Multiplier : '';
    });
    return result;
  }

  getValues() {
    return this.targetsView ? this.targetsView.getValues() : [];
  }

  setData(dataset) {
    this.targetsView.viewmodel.setData(dataset);
  }

  setLevel(level) {
    this.options.level = level;
    this.targetsView.setLevel(level);
  }

  handleErrors(response) {
    return this.targetsView.handleErrors(response);
  }

  validate() {
    const isValid =  this.targetsView.validate();

    if (!isValid && this.options.activityLogger) {
      this.options.activityLogger.signal(`${this.options.targetType} bid adjustment is not valid`, `${this.options.targetType} target`);
    }

    return isValid;
  }
}
